

import React from "react";
import { IconProps } from ".";

export const DeleteFilled = ({
  className = '',
  color = '#D9D9D9',
  width = '21px', height = '21px'
}: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} width={width} height={height} viewBox="0 0 21 21" fill="none">
    <mask id="mask0_1_1992" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width={width} height={height}>
      <rect x="0.992188" y="0.191406" width="20" height="20" fill={color} />
    </mask>
    <g mask="url(#mask0_1_1992)">
      <path d="M6.8255 17.6914C6.36717 17.6914 5.97494 17.5284 5.64883 17.2022C5.32217 16.8756 5.15883 16.4831 5.15883 16.0247V5.19141H4.3255V3.52474H8.49217V2.69141H13.4922V3.52474H17.6588V5.19141H16.8255V16.0247C16.8255 16.4831 16.6624 16.8756 16.3363 17.2022C16.0097 17.5284 15.6172 17.6914 15.1588 17.6914H6.8255ZM15.1588 5.19141H6.8255V16.0247H15.1588V5.19141ZM8.49217 14.3581H10.1588V6.85807H8.49217V14.3581ZM11.8255 14.3581H13.4922V6.85807H11.8255V14.3581Z" fill="#FF8F73" />
    </g>
  </svg>
);
